module.exports = __webpack_public_path__ + "img/button-icon1.6b175fb7.png";